const getAuthToken = () => {
  try {
    const tokenData = sessionStorage.getItem("authToken") || localStorage.getItem("authToken");
    if (!tokenData) return null;
    try {
      const parsed = JSON.parse(tokenData);
      return parsed.access || parsed.access_token || parsed.token;
    } catch {
      // Token is a raw JWT string, not JSON
      return tokenData;
    }
  } catch (e) {
    console.error("Error retrieving auth token:", e);
  }
  return null;
};

export const getLegalAdvisories = async () => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/legal-advisory-requests/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};
export const getLegalAdvisoriesByProsecutor = async (prosecutor_user_id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/legal-advisory-requests/by-prosecutor/?prosecutor_user_id=${prosecutor_user_id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};

export const getLegalAdvisoriesByStakeholder = async (stakeholder_id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/legal-advisory-requests/by-stakeholder/?stakeholder_id=${stakeholder_id}`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};
export const getLegalAdvisory = async (id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/legal-advisory-requests/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "GET",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to get Legal Advisory request");
    }
    return response.json();
};

export const createLegalAdvisory = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/legal-advisory-requests/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const updateLegalAdvisory = async (id: string, data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/legal-advisory-requests/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to update Legal Advisory request");
    }
    return response.json();
};

export const createLegalFeedback = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/legal-advisory-feedbacks/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};


export const createLegalRespondbackFeedback = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/legal-advisory-respondback-feedbacks/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};


export const createLegalAdvisoryRemark = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/legal-advisory-remarks/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const createLegalAdvisoryProsecutorAssignment = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/prosecutor-assignments/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const updateLegalAdvisoryProsecutorAssignment = async (id: string, data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/prosecutor-assignments/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const deleteLegalAdvisoryProsecutorAssignment = async (id: string) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/prosecutor-assignments/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "DELETE",
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
};

export const createLegalAdvisoryAdditionalInfo = async (data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/legal-advisory-additional-info/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "POST",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

export const updateLegalAdvisoryAdditionalInfo = async (id: string, data: FormData) => {
    const token = getAuthToken();
    const response = await fetch(
        `${process.env.REACT_APP_API_BASE_URL}legal_advisory/legal-advisory-additional-info/${id}/`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
            method: "PATCH",
            body: data
        }
    );
    if (!response.ok) {
        const errorBody = await response.text();
        console.log(errorBody);
        throw new Error("Failed to create Legal Advisory request");
    }
    return response.json();
};

